<template>
  <div class="contact-floating">
    <div class="item" @mouseenter="hover='phone'" @mouseleave="hover=''">
      <i class="el-icon-phone-outline"></i>
      <transition name="fade-slide">
        <div v-if="hover==='phone'" class="panel phone">
          <div class="row">热线：{{ phone }}</div>
          <div class="row time">时间：{{ serviceTime }}</div>
        </div>
      </transition>
    </div>

    <div class="item" @mouseenter="hover='wechat'" @mouseleave="hover=''">
      <i class="el-icon-chat-round"></i>
      <transition name="fade-slide">
        <div v-if="hover==='wechat'" class="panel qrcode">
          <img :src="wechatQr" alt="微信二维码" />
          <p>微信</p>
        </div>
      </transition>
    </div>

    <div class="item" @mouseenter="hover='mp'" @mouseleave="hover=''">
      <i class="el-icon-message"></i>
      <transition name="fade-slide">
        <div v-if="hover==='mp'" class="panel phone">
          <!-- <img :src="mpQr" alt="公众号二维码" /> -->
          <div class="row">邮箱：{{ email }}</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactFloating',
  props: {
    phone: { type: String, default: '18627010615' },
    email: { type: String, default: '115956559@qq.com' },
    serviceTime: { type: String, default: '8:00 - 20:00' },
    wechatQr: { type: String, default: () => require('../assets/img/wx_qrcode.png') },
    mpQr: { type: String, default: () => require('../assets/img/qrcode.jpg') }
  },
  data() {
    return {
      hover: ''
    };
  }
};
</script>

<style lang="scss" scoped>
.contact-floating {
  position: fixed;
  right: 2rem;
  bottom: 20%;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .item {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    color: #005a62;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;

    i { font-size: 20px; }

    .panel {
      position: absolute;
      right: 56px;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0,0,0,0.72);
      color: #fff;
      border-radius: 8px;
      padding: 10px 12px;
      white-space: nowrap;
    }

    .phone {
      min-width: 180px;
      .row { font-size: 1.25rem; }
      .label { opacity: 0.9; margin-right: 6px; }
      .time { opacity: 0.9; margin-top: 4px; }
    }

    .qrcode {
      text-align: center;
      img { width: 120px; height: 120px; object-fit: cover; display: block; border-radius: 4px; }
      p { margin-top: 6px; font-size: 12px; opacity: 0.9; }
    }
  }
}

.fade-slide-enter-active, .fade-slide-leave-active { transition: all .2s ease; }
.fade-slide-enter, .fade-slide-leave-to { opacity: 0; transform: translate(-6px, -50%); }
</style>


